import BrandPlansList from "../BrandPlansList";

const BrandDeadline = () => {
  return <BrandPlansList type={"initiativeFilters"} isInitiativeFilterVisible />;
};

export default BrandDeadline;
